import { render, staticRenderFns } from "./PortsComparison.vue?vue&type=template&id=bd6335c6&scoped=true&"
import script from "./PortsComparison.vue?vue&type=script&lang=js&"
export * from "./PortsComparison.vue?vue&type=script&lang=js&"
import style0 from "./PortsComparison.vue?vue&type=style&index=0&id=bd6335c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6335c6",
  null
  
)

export default component.exports